export const hardRedirect = (url: string): void => {
  window.location.replace(url);
};
